module.exports = __webpack_public_path__ + "static/media/hospitals.beb7b5dc.svg";